import { initDataTableCtrl } from './functions-scenarios.js';


export function initDataTable(){

  ////////////////////// DATA TABLES. woo hoo

  var showPricing = $('.show-pricing-hidden').val()

  //////////// aTargets determines which columns are NOT active for sorting

  if (showPricing){
    // var aTargets = [ 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ]
    var aTargets = [ 0, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13 ]
    var columnNames = [
        { className: "lg md sm xs" },
        { className: "xxl xl lg md sm" },
        { className: "xxl xl lg md sm" },
        { className: "xxl xl lg md sm xs" },
        { className: "xxl xl lg md sm" },
        { className: "xxl xl lg md sm" },
        { className: "xxl xl" },
        { className: "xxl xl" },
        { className: "xxl xl" },
        { className: "xxl xl" },
        { className: "xxl xl lg md" },
        { className: "xxl xl lg md" },
        { className: "xxl xl lg md" },
        { className: "xxl xl lg md sm xs" },
      ]
  } else {
    // var aTargets = [ 0, 3, 4, 5, 6, 7, 8, 9, 10 ]
    var aTargets = [ 0, 3, 4, 5, 6, 7, 8, 9, 10, 11 ]
    var columnNames = [
      { className: "lg md sm xs" },
      { className: "xxl xl lg md sm" },
      { className: "xxl xl lg md sm" },
      { className: "xxl xl lg md sm xs" },
      { className: "xxl xl lg md sm" },
      { className: "xxl xl lg md sm" },
      { className: "xxl xl" },
      { className: "xxl xl" },
      { className: "xxl xl lg md" },
      { className: "xxl xl lg md" },
      { className: "xxl xl lg md" },
      { className: "xxl xl lg md sm xs" },
      ]
  }

  scenarioTableDT = $('#scenario-table').DataTable({
    "info": false,
    "paging": false,
    "searching": false,
    "language": {
        "zeroRecords": "Add a product to the scenario...",
    },
    "drawCallback": function( settings ) {
      var api = this.api();
      // Initialize custom controls. Select2 for example.
      initDataTableCtrl(api.table().container());
    },
    responsive: {
        breakpoints: [
          // { name: 'xl',  width: 1600 },
          { name: 'lg',  width: 1360 },
          { name: 'md',  width: 1200 },
          { name: 'sm',  width: 1020 },
          { name: 'xs',   width: 767 }
        ],
        details: {
          display: $.fn.dataTable.Responsive.display.modal( {
                    header: function ( row ) {
                        console.log("Row", row);
                        var data = row.data();
                        var html = ""
                        html += "<div class='dt-row-id' style='display: none'>"+data.DT_RowId+"</div>"
                        html += "<div class='product-data' data-product='' style='display: none'></div>"
                        return html
                    }
                } ),
          renderer: function ( api, rowIdx, columns ) {

              var data = $.map( columns, function ( col, i ) {

                  if ( col.columnIndex == 1 && col.data ) {
                    // this is the "week select" column
                    var temp = $(col.data)

                    var val = localStorage.weeksDisplay;

                    if ( val == 'dates' ) {
                      weeksArray = ["Jan 1", "Jan 8", "Jan 15", "Jan 22", "Jan 29", "Feb 5", "Feb 12", "Feb 19", "Feb 26", "Mar 5", "Mar 12", "Mar 19", "Mar 26", "Apr 2", "Apr 9", "Apr 16", "Apr 23", "Apr 30", "May 7", "May 14", "May 21", "May 28", "Jun 4", "Jun 11", "Jun 18", "Jun 25", "Jul 2", "Jul 9", "Jul 16", "Jul 23", "Jul 30", "Aug 6", "Aug 13", "Aug 20", "Aug 27", "Sep 3", "Sep 10", "Sep 17", "Sep 24", "Oct 1", "Oct 8", "Oct 15", "Oct 22", "Oct 29", "Nov 5", "Nov 12", "Nov 19", "Nov 26", "Dec 3", "Dec 10", "Dec 17", "Dec 24"];
                    } else {
                      weeksArray = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7", "Week 8", "Week 9", "Week 10", "Week 11", "Week 12", "Week 13", "Week 14", "Week 15", "Week 16", "Week 17", "Week 18", "Week 19", "Week 20", "Week 21", "Week 22", "Week 23", "Week 24", "Week 25", "Week 26", "Week 27", "Week 28", "Week 29", "Week 30", "Week 31", "Week 32", "Week 33", "Week 34", "Week 35", "Week 36", "Week 37", "Week 38", "Week 39", "Week 40", "Week 41", "Week 42", "Week 43", "Week 44", "Week 45", "Week 46", "Week 47", "Week 48", "Week 49", "Week 50", "Week 51", "Week 52"];
                    } 

                    // temp is a jquery object with the select inside
                    // we need to modify the label of each option from Weeks to Dates
                    temp.find('option').each( function( index, element ){
                      
                        $(element).text( weeksArray[ index ] )

                        // select the correct option
                        if ( $(element).attr('selected') == 'selected' ) {
                          $(element).attr('selected', 'selected')
                        }

                    } )
                  

                    col.data = temp[0].outerHTML
                    col.title = $(col.title).text()
                  }


                  /// WHAT DOES THIS DO????
                  // if ( col.columnIndex == 3) {
                  //   var temp = $(col.data)
                  //   col.data = temp[0].outerHTML
                  //   // console.log(col.data);
                  //   var width = $( window ).width();
                  //   if (width<1200){
                  //     col.hidden = true
                  //   }
                  // }

                  return col && col.title && col.columnIndex != 0 && col.columnIndex != 4 ?
                      '<tr data-dt-row="'+col.rowIndex+'" data-dt-column="'+col.columnIndex+'">'+
                          '<td>'+col.title+'</td> '+
                          '<td>'+col.data+'</td>'+
                      '</tr>' :
                      '';

              } ).join('');

              var table = $('<table/>').append( data )
              var container = $('<div/>').append( table )

              var inner = '<button type="button" class="btn btn-secondary cancel">Cancel</button>'
              inner += '<button type="button" class="btn btn-primary done">Done</button>'

              var footerDiv = $('<div class="fake-modal-footer"/>').append( inner )

              container.append(footerDiv)

              return container
          }
        }
    },
    order: [],
    columns: columnNames,
    columnDefs: [
            {
                targets: 1,
                data: {
                    _: "1.display",
                    sort: "1.@data-order",
                    type: "1.@data-order"
                }
            },
            {
              targets: aTargets,
              orderable: false
            }
        ]
  });


}
